// extracted by mini-css-extract-plugin
export default {"innerWrapper":"zx-z","tooltipWrapper":"Ax-z","icon":"Bx-z","tooltip":"Cx-z","content":"Dx-z"};